let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fmzVU")).then(() => parcelRequire('8rvy7'));